

import {
  Building2,
  Users,
  Calendar,
  CalendarDays,
  Settings,
} from 'lucide-react';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from '@/components/ui/sidebar';

const menuItems = [
  { 
    title: 'Propiedades', 
    value: 'properties', 
    icon: Building2 
  },
  { 
    title: 'Huéspedes', 
    value: 'guests', 
    icon: Users 
  },
  { 
    title: 'Reservaciones', 
    value: 'bookings', 
    icon: CalendarDays 
  },
  { 
    title: 'Calendario', 
    value: 'calendar', 
    icon: Calendar 
  },
  { 
    title: 'Usuarios', 
    value: 'users', 
    icon: Settings 
  },
];

interface AdminSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const AdminSidebar = ({ activeTab, onTabChange }: AdminSidebarProps) => {
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';

  return (
    <Sidebar 
      className={`${isCollapsed ? 'w-16' : 'w-64'} top-16`} 
      collapsible="icon"
      style={{ height: 'calc(100vh - 4rem)' }}
    >
      <SidebarContent className="pt-2">
        <div className="flex justify-end p-2">
          <SidebarTrigger />
        </div>
        
        <SidebarGroup>
          <SidebarGroupLabel className={isCollapsed ? 'sr-only mb-2' : 'px-4 mb-2'}>
            Administración
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu className="space-y-1 px-2">
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.value}>
                  <SidebarMenuButton 
                    onClick={() => onTabChange(item.value)}
                    isActive={activeTab === item.value}
                    tooltip={isCollapsed ? item.title : undefined}
                    size="lg"
                    className={`
                      w-full h-12 px-3 justify-start
                      ${activeTab === item.value 
                        ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' 
                        : 'hover:bg-gray-100'
                      }
                    `}
                  >
                    <item.icon className="h-5 w-5 mr-3" />
                    {!isCollapsed && <span className="text-base">{item.title}</span>}
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};

export default AdminSidebar;

